import { User } from './user';
import { UnitOfMeasure } from './unit-of-measure';
import { LoadingFormat } from './loading-format';
import { CommodityPackaging } from './commodity-packaging';

export class Packaging {
  name!: string;
  description?: string;
  package_weight?: string;
  unit_of_measure_uuid?: string;
  package_has_small_units?: boolean;
  name_of_small_units?: string;
  number_of_small_units?: number;
  weight_of_small_units?: number;
  package_has_loading_format?: boolean;
  loading_format_uuid?: string;
  status!: string;
  user_uuid!: string;
  date_deleted?: number;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;
  unit_of_measure?: UnitOfMeasure;
  loading_format?: LoadingFormat;
  commodity_packagings?: Array<CommodityPackaging>;

  static getSortColumns() {
    return ['name', 'description', 'package_weight', 'status'];
  }

  constructor(data: any) {
    this.name = data.name;
    this.description = data.description;
    this.package_weight = data.package_weight;
    this.unit_of_measure_uuid = data.unit_of_measure_uuid;
    this.package_has_small_units = data.package_has_small_units;
    this.name_of_small_units = data.name_of_small_units;
    this.number_of_small_units = data.number_of_small_units;
    this.weight_of_small_units = data.weight_of_small_units;
    this.package_has_loading_format = data.package_has_loading_format;
    this.loading_format_uuid = data.loading_format_uuid ?? data.loading_format;
    this.status = data.status;
    this.user_uuid = data.user_uuid;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
    if (data.unit_of_measure) {
      this.unit_of_measure = new UnitOfMeasure(data.unit_of_measure);
    }
    if (data.loading_format) {
      this.loading_format = new LoadingFormat(data.loading_format);
    }
    if(data.commodity_packagings){
      this.commodity_packagings = data.commodity_packagings.map((el: any) => new CommodityPackaging(el));
    }
  }
}
